export default "__VITE_ASSET__DgPkmbAw__"